<button type="button"
        class="btn btn-link"
        style="display: inline-flex; align-items: center; justify-content: center; padding-top: 0; padding-bottom: 0; line-height: 1;"
        (click)="edit()"
        data-test="EditPlan">
  <i class="fas fa-sm fa-edit" style="vertical-align: middle;"></i>
</button>
<button type="button"
        class="btn btn-link"
        style="display: inline-flex; align-items: center; justify-content: center; padding-top: 0; padding-bottom: 0; line-height: 1;"
        (click)="delete()"
        [disabled]="$any(data).isReadonly">
  <i class="fas fa-sm fa-trash-alt" style="vertical-align: middle;"></i>
</button>
